import { makeStylesheetLink } from "@self/stylesheet";

export class CompanyCheckbox extends HTMLElement {
	shadow: ShadowRoot;
	input: HTMLInputElement;
	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.input = <input type="checkbox" name="company-name-input" /> as HTMLInputElement;

		this.onClick = onClick.bind(this);

		this.shadow.append(
			<label className="gct-custom-checkbox">
				{this.input}
				<span>This is a company address</span>
			</label>,
			makeStylesheetLink(),
		);
	}

	connectedCallback() {
		this.input.checked = this.dataset.checked !== undefined;
		this.input.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.input.removeEventListener("click", this.onClick);
	}
}

function onClick(this: CompanyCheckbox) {
	const target = this.dataset.target!;

	const input = document.getElementById(target) as HTMLInputElement;
	const container = input.parentNode as HTMLDivElement;

	if (this.input.checked) {
		container.style.display = "";
	} else {
		container.style.display = "none";
		input.value = "";
	}
}
